import { gql } from "graphql-tag";

export const GET_TICKET_COUNTS_BY_VIEW = gql`
  query GetTicketCountsByView($filter: TicketFilterInput) {
    ticketCountsByView(filter: $filter) {
      my
      all
      unassigned
      allMyQueues
      draftTickets
      critical
    }
  }
`;

export const GET_TICKETS = gql`
  query GetTickets(
    $pagination: PaginationInput
    $filter: TicketFilterInput
    $sort: TicketSortInput
  ) {
    tickets(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        id
        ticketNumber
        accountId
        locationId
        assetId
        problemCategoryId
        contactId
        title
        description
        status
        priority
        scheduledDate
        waitingSparePartsDate
        createdByUserId
        assignedToUserId
        lastUpdatedByUserId
        createdAt
        updatedAt
        location {
          id
          name
        }
        asset {
          id
          name
        }
        problemCategory {
          id
          name
        }
        createdByUser {
          id
          firstName
          lastName
        }
        assignedToUser {
          id
          firstName
          lastName
        }
        lastUpdatedByUser {
          id
          firstName
          lastName
        }
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_TICKET = gql`
  query GetTicket($id: ID!) {
    ticket(id: $id) {
      id
      ticketNumber
      requesterEmail
      accountId
      locationId
      assetId
      problemCategoryId
      contactId
      title
      description
      status
      priority
      scheduledDate
      waitingSparePartsDate
      createdByUserId
      assignedToUserId
      lastUpdatedByUserId
      createdAt
      updatedAt
      location {
        id
        name
      }
      asset {
        id
        name
      }
      problemCategory {
        id
        name
      }
      createdByUser {
        id
        firstName
        lastName
      }
      assignedToUser {
        id
        firstName
        lastName
      }
      attachments {
        id
        ticketId
        fileUrl
        fileName
        mimeType
        createdAt
        updatedAt
      }
      activities {
        id
        accountId
        ticketId
        createdByUserId
        externalAuthorEmail
        sentToEmail
        type
        visibility
        isInternal
        message
        meta
        createdAt
        updatedAt
        createdByUser {
          id
          name
        }
      }
      isCurrentUserQueueMember
      ticketQueueSummaries {
        id
        name
        isDefault
      }
    }
  }
`;
